// extracted by mini-css-extract-plugin
module.exports = {"J_10":"J_J_10__Z5N1F"};